import { OptionSelectedEvent, VariantUpdatedEvent } from '@theme/events';

(function variantPicker() {
  'use strict';

  const SELECTORS = {
    MAIN_PRODUCT: '[data-main-product]',
    PRODUCT_JSON: '[data-product-json]',
    FORM_ELEMENT: 'form[action="/cart/add"]',
    VARIANT_ID: 'input[name="items[0]id"]',
    VARIANT_SELECTOR: '[data-variant-select]'
  };

  const formElements = Array.from(document.querySelectorAll(SELECTORS.FORM_ELEMENT));
  formElements.forEach(formElement => init(formElement));

  // The theme editor re-renders the section on every setting change, replacing the option inputs: rebind them.
  document.addEventListener('shopify:section:load', (event) => {
    Array.from(event.target.querySelectorAll(SELECTORS.FORM_ELEMENT)).forEach(init);
  });

  function init(formElement) {
    const mainProduct = document.querySelector(SELECTORS.MAIN_PRODUCT);
    const productJson = mainProduct.querySelector(SELECTORS.PRODUCT_JSON);
    const { variants, productId } = JSON.parse(productJson.innerHTML);

    const variantSelectors = Array.from(formElement.elements)
      .filter(element => element.matches(SELECTORS.VARIANT_SELECTOR));

    variantSelectors.forEach(variantSelector => {
      variantSelector.addEventListener('change', ()=> handleVariantChange({variantSelectors, variantSelector, variants, productId, formElement}));
    });
  }

  function handleVariantChange({variantSelectors, variantSelector, variants, productId, formElement}) {
    const variant = getSelectedVariant({variantSelectors, variants});

    document.dispatchEvent(new OptionSelectedEvent({
      productId: productId,
      variant: variant,
      formElement: formElement,
      option: { name: variantSelector.name, value: variantSelector.value },
    }));

    if (variant) {
      document.dispatchEvent(new VariantUpdatedEvent({
        productId: productId,
        variant: variant,
        formElement: formElement,
      }));

      updateVariantId({variant, formElement});
      updateUrl(variant);
    }
  }

  function getSelectedVariant({variantSelectors, variants}) {
    const checkedVariantSelectors = variantSelectors.filter(variantSelector => variantSelector.checked);
    const newSelectedValues = checkedVariantSelectors.map(variantSelector => variantSelector.value);

    return variants.find(variant => JSON.stringify(variant.options) === JSON.stringify(newSelectedValues));
  }

  function updateVariantId({variant, formElement}) {
    const variantIdInput = formElement.querySelector(SELECTORS.VARIANT_ID);

    if (!variantIdInput) {
      console.warn('updateVariantId: Variant id input element not found');
      return;
    }

    variantIdInput.value = variant.id;
  }

  function updateUrl(variant) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);

    if (url.href !== window.location.href) {
      history.replaceState({}, '', url.toString());
    }
  }

})();
